import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SiteHeader from "./components/SiteHeader/SiteHeader";
import Footer from "./components/Footer/Footer";
import FruitPulpPage from "./pages/fruit-pulp/fruit-pulp";
import MarinatedChickenPage from "./pages/marinated-chicken/marinated-chicken";
import SeafoodPage from "./pages/seafood/seafood";
import HomePage from "./pages/home/home";
import AboutUs from "./pages/AboutUs/AboutUs";
import ContactUs from "./pages/ContactUs/ContactUs";
import ContactSocialIcons from "./components/ContactSocialIcons/ContactSocialIcons";
import BrochurePage from "./pages/brochure";


function App() {
  return (
    <div className="App">
      <Router>
        <SiteHeader />
        <main>
          <Routes>
            <Route path="/marinated-chicken" element={<MarinatedChickenPage />} />
            <Route path="/seafood" element={<SeafoodPage />} />
            <Route path="/fruit-pulp" element={<FruitPulpPage />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/brochure" element={<BrochurePage />} />
            <Route path="/" element={<HomePage />} /> {/* Default route */}
          </Routes>
        </main>
        <ContactSocialIcons />
        <Footer />
      </Router>
    </div>
  );
}

export default App;
